import React from 'react';
import { Link } from 'react-router-dom';

const About = () => {
    return (
        <>
            <div className="bg about-bg">
                <h1 className="text-4xl sm:text-6xl font-bold mb-4 animate-fade-in">Welcome to AdSki</h1>
                    <p className="text-lg sm:text-xl font-light mb-6 animate-fade-in-delay">
                        Make the Right Choice! <br /> Do you need a consultation? We are here to help. Call Us Now!
                    </p>
                    <Link to="/contact">
                        <button className="px-6 sm:px-8 py-3 sm:py-4 bg-black hover:bg-black-700 text-white font-semibold text-base sm:text-lg rounded-lg shadow-md transition duration-300 animate-bounce">
                            Contact Us Now
                        </button>
                    </Link>
            </div>

            {/* Main Content */}
            <section className="pt-24 sm:py-12 px-4 sm:px-10 lg:px-16">
                <div className="max-w-screen-2xl mx-auto">
                    {/* About Description */}
                    <div className="text-justify">
                        <p className="leading-relaxed sm:mb-8">
                            At <span className="font-bold text-gray-900">AdSki</span>, we specialize in driving results through cutting-edge performance marketing strategies. Whether you need a high-converting website, powerful ad campaigns, or seamless automation, we deliver data-driven solutions that elevate your brand's digital presence.
                        </p>
                        <p className="leading-relaxed sm:mb-8">
                            Our team of marketing experts is dedicated to helping businesses grow through innovative strategies that drive traffic, generate leads, and maximize conversions. With a customer-first approach, we tailor each campaign to meet your unique business goals, ensuring measurable success and long-term growth.
                        </p>
                    </div>
                </div>
            </section>

            <section className="clear-both m-auto justify-center px-4 sm:px-8">
                <div className="grid lg:grid-cols-1 gap-8 sm:gap-12 max-w-screen-xl">
                    {/* Why Choose AdSki */}
                    <div className="lg:pl-12 flex items-center">
                        <div className="w-full">
                            <h2 className="text-3xl sm:text-3xl lg:text-3xl font-bold mb-6 sm:mb-8 text-gray-800">Why Choose AdSki?</h2>
                            <p className="text-base sm:text-lg leading-relaxed text-gray-700 mb-4 sm:mb-6">
                                At AdSki, we are committed to helping businesses grow through innovative marketing solutions. Here's why you should choose us:
                            </p>
                            <ul className="list-inside space-y-3 sm:space-y-4 text-base sm:text-lg text-gray-700">
                                <li className="flex items-start space-x-2">
                                    <span className="text-blue-600">✅</span>
                                    <span>Data-Driven Strategies for Maximum ROI</span>
                                </li>
                                <li className="flex items-start space-x-2">
                                    <span className="text-blue-600">✅</span>
                                    <span>Customized Solutions for Your Business Needs</span>
                                </li>
                                <li className="flex items-start space-x-2">
                                    <span className="text-blue-600">✅</span>
                                    <span>High-Quality Leads & Conversions</span>
                                </li>
                                <li className="flex items-start space-x-2">
                                    <span className="text-blue-600">✅</span>
                                    <span>Experienced Team of Marketing Experts</span>
                                </li>
                                <li className="flex items-start space-x-2">
                                    <span className="text-blue-600">✅</span>
                                    <span>Transparent Reporting & Performance Tracking</span>
                                </li>
                                <li className="flex items-start space-x-2">
                                    <span className="text-blue-600">✅</span>
                                    <span>Affordable Pricing Plans for Every Budget</span>
                                </li>
                                <li className="flex items-start space-x-2">
                                    <span className="text-blue-600">✅</span>
                                    <span>Cutting-Edge Technology & Automation Tools</span>
                                </li>
                                <li className="flex items-start space-x-2">
                                    <span className="text-blue-600">✅</span>
                                    <span>Proven Results & Success Stories</span>
                                </li>
                                <li className="flex items-start space-x-2">
                                    <span className="text-blue-600">✅</span>
                                    <span>Dedicated Support for Every Client</span>
                                </li>
                            </ul>
                            <p className="text-base sm:text-lg font-semibold text-gray-800 mt-6 sm:mt-8 mb-6 sm:mb-8">
                                Let's Grow Your Business Together! Take your brand to new heights with AdSki. Whether you're a startup or an established business, our performance marketing solutions are designed to accelerate your growth.
                            </p>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default About;
